module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('div', {
    staticClass: "gif"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Heading-1 ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "ded"
    }
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("This")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("b")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ook")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("is")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("de")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("icated")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("any")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("o")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ne")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("w")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("h")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("o")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_c('br')]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("loves")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("someone")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("str")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("u")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ggling")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("with")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("dict")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("i")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("An")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(",")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("as")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("l")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ways,")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Mom,")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Dad,")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Mi")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("c")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("h")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("el")])]), _vm._v(" "), _c('div', {
    staticClass: "gif"
  }, [_c('img', {
    attrs: {
      "alt": "blank",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal2 ParaOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "sideA"
    }
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("side A")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("the poems")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track One")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("This is dedicated to the man who saved me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("He didn’t save me from a car wreck;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my existence managed to swerve off the road,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("creating a mangled mess even the")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Jaws of Life couldn’t tear through.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("He didn’t save me from fiery flames.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Quite the contrary, and perhaps")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("even a bit more frightening, the fire inside ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of me had long burned out.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("He didn’t save me from drowning, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("at least not in the literal sense.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I can swim just fine and still the rip currents ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of life took me under, and I began")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to flounder in my own tears.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Simply, this is dedicated to the man who saved ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("me from the biggest catastrophe of all: ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("myself")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Liste")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ning To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Ellie Goulding, “How Lo")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ng Will I Love You?”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Two")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You always want one more day. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You always want one more picture ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as the old ones begin to fade.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You always want that one final hug ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to have lasted just a tad longer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You always want the fondness ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of the ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("remember-whens")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to outnumber the ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("might-have-beens")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You want more years, more months,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("more weeks, more days,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("more minutes, and more seconds. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You want the ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("happily ever after")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you always thought you deserved,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but the only thing actually promised ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in this life is uncertainty.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Rod Ste")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("wart, “Forever Young”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Three")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I    c o m b    thro")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ugh my memories")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("with more")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("care than I d")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("o my hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I’m told the key")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" is to preserve the root.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Still, I have")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" difficulty remembering things.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I recall second natures ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-14"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("p")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-15"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-15"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("r ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-15"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-15"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("i ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-15"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-15"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("l ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-15"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("never w")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("holes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I flip through photo al")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("bums")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and see my likeness in s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("omeone")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-18"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I can’t manage to recog")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nize anymore,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-19"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("even when I squint.")])]), _vm._v(" "), _c('p', {
    staticClass: "Italic-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("She shares my fingerprint")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("s. "), _c('br'), _vm._v("They tell me it’s me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s as ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("if I am wearing ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hand-me-dow")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n memories")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("from a life that doesn’t fit quit")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e right.")])]), _vm._v(" "), _c('p', {
    staticClass: "Italic-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("They were a gift,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_c('br')]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("so s")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("queeze into them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-23"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I experience that ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("familiar itch of frustration ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-23"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I struggle to name the girl in t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("he photo.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Imagine the anguish")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" felt")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-24"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("by having your very own ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("existence ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-24"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on the tip of your t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ongue.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Sara")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" Bareilles, “She Used to Be Min")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("e”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Four")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yeah, she’s beautiful.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Anyon")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e with decent eyesight can ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("tell you that."), _c('br'), _c('br')]), _c('span', {
    staticClass: "Italic-Text2"
  }, [_vm._v("That’s not why  I love her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I love her when ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("she is putting on her makeup, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sittin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g on the bathroom counter.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I lo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ve her when she makes me order")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the Chinese or pizza")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but cons")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("tantly whispers the ord")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("er ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("into my ear because ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("she is convinced ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ll mess it ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I love her when we are w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("alking")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-26"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and she trips over nothin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g on the sidewalk ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-26"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and keeps")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" talking, not missing a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" beat,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("like it just didn’t happ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("en.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-27"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I love her when we are p")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("acking the car ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-27"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for a trip ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and she hands me seven bags.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I love her when she is curled up")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on our couch wearing my shirt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I love her after her first si")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("p of coffee ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("or her last s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ip of wine.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I love her when")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" she first gets out of the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("shower "), _c('br'), _vm._v("in the summer and I se")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e her vivid tan lines.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I love")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" her when she steals the covers al")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("l night ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and then, come morning,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("blames")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" me for turning on the fan.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-31"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" love her when we drive du")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ring the holidays, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-31"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("her feet up ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on the dashboard,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sipping hot chocolate")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" and")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("looking at Christmas l")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ights.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Lee Brice, “A Woman Like You”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Five")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("She jumped from one happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the next. ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("(You’re the only one.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("They made her smile ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("(You’re beautiful)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("until ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("they made her cry")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("(But I’m not ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("looking to settle down.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("They ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("broke her heart ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("(This isn’t ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("working")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" anymore,) ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and her spirit ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("(But ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("let’s still be friends.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Over a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nd over again,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("she trusted the     f")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" r a g m e n t s")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of her")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" soul with others")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("(I’d never hurt you ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("like he did.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("She thought they coul")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d fix her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Once they inevita")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("bly abandoned her")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("(It’s not you, ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("it’s me)")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" she would end up")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("leaving with")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" more of them than of herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And this is how a person’s own r")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eflection ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("can become unrecognizable.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("O.A.R., ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("“Shattered”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Six")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The strongest")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" people I know")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have been overtaken")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" by their weaknesses.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "Italic-Text CharOverride-8"
  }, [_vm._v("They know ")]), _c('span', {
    staticClass: "Italic-Text CharOverride-8"
  }, [_vm._v("what it’s like to lose control.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" strongest people I know")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" cried in the shower and in ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("their car.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "Italic-Text CharOverride-8"
  }, [_vm._v("They know loss and ")]), _c('span', {
    staticClass: "Italic-Text CharOverride-8"
  }, [_vm._v("guilt all too well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The stron")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("gest people I know aren’t bulletp")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("roof.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "Italic-Text CharOverride-8"
  }, [_vm._v("They have felt the searing pain ")]), _c('span', {
    staticClass: "Italic-Text CharOverride-8"
  }, [_vm._v("of life’s shots.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The stronges")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t people I know")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("make the decision ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("every day to wake up ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("place their two feet on the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ground")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("even though they know th")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e monsters beneath ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("their bed will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" grab at their ankles.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The strongest people I know")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("are")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" not ")]), _c('span', {
    staticClass: "Italic-Text CharOverride-8"
  }, [_vm._v("strong")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" by definition, at")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" all.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("They are mistake-maker")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("They are mess-creators.")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("They are survivors.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("50 Cent, “In Da Club”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seven")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("To Whom I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t May Concern:")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Drive away. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You don’t live here anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You are not home free if you ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("are still calling this ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("place Home. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Check your mirrors. ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Images are")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v(" closer")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("than they appear and ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("not as pretty as they see")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("m.")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Those rose-colored sungl")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("asses of yours are playing ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("tricks on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" your eyes. This nostalgic route")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" is messing ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("with your heart. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("That familiar song on the r")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("adio ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("has penetrated your mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("onestly, I hope you don’t spend ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("one minute ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("missing me. Missin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g this. You will heal as lon")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g as ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you don’t turn around. ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Ever.")]), _vm._v(" Sometimes even a ")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("glance into ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the past can kill you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Sincerely,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("he Girl You Used to Be")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Curre")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ntly Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The Weepies")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(", “Can’t Go Back Now”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eight")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("She lost her")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("self.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’m talking ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("down-the-rabbit-hole-free-fall  ")]), _vm._v(" like the")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("little")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" blonde girl in that book she rea")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d once. She ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("was so far go")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ne, even her own shadow kicke")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d her ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("when she was down. F")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("riends and family would tell ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("her s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("he would be her  "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("old self")]), _vm._v(" in no ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("time flat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("You’ll find yourself again,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" they would say. They ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("would promise")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" her this in hopes she would find ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("comf")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ort in the possibility. They m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ade it seem like a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("blessing.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" To her, the idea of becoming hers")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("elf again ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("felt more like a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("curse. Why would she purposely")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("go")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" hunting for that girl just to feel al")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("l the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("pain she had once felt?")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Why?")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" If that meant having the memories, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("mistakes, and regrets find ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("her again, too? No, she ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("didn’t w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ant to become her "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("old self ")]), _vm._v("again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("If")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" she survived her latest mis")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("adventure,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("she vowed to become ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("someone entirely new.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening T")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("o:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Rachel Platten, “Fight Song”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Nine")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" first time my heart broke,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I thought back to"), _c('br'), _vm._v("the day in my ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("childhood when a piece ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of glass went"), _c('br'), _vm._v("through my f")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("inger after an ill-fated cart")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wheel.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("I was eleven years old.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My mother and I were in our bat")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hroom cleaning ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("up the wound. She ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dribbled peroxide onto the cut. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It fiz")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("zed and burned; I winced ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("at the pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("It needs to burn so y")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("ou know it’s healing,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("she explained.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("That sma")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ll exchange during my adol")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("escence helped ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("me learn to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("appreciate the pain pulsating from my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("broken heart. In spite of the s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("everity of my wound, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I knew ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the healing process had alrea")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dy begun.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ing To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Big Sean, “Dark Sky (Sky")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("scrapers)”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Ten")]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I had become accustomed to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("using moving boxes "), _c('br'), _vm._v("as makesh")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ift coffee tables. I was ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("never in one place "), _c('br'), _vm._v("for too ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("long and always in my car ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("longer than any "), _c('br'), _vm._v("bed; but the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("re was an anomaly in that las")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t drive.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It was one of thos")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e special car rides where every ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ong on the radio was one of")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my favorites. The ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("road was ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("open and smooth, freshly paved.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nd the thing is, I wasn’t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" driving anywhere new.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("For o")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nce in my life, ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("home")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" had become a")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("singular destination for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I regai")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ned my soul through you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" regained my soul through")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" our consistency.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ing To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-Title"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Sonny & Cher, “I G")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ot You Babe”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eleven")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You can taste ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sorrow in salt tears and")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" in the "), _c('br'), _vm._v("bitterness of spoiled words ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("left in your mouth "), _c('br'), _vm._v("for far to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("o long.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You can hear s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("orrow in a familiar song. You c")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hide sorrow behind closed")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" doors and inside ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("screams muffled by ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("pillowcases.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-35"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You can sti")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ck to sorrow as if it were ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("gum ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-35"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in your hair; too mangled to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("brush out, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-35"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("too jarring ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to chop off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You can see sor")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("row in")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("bloodshot eyes and shaky ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You can get lost ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in sorrow when it knocks your")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" life ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("off course with no detour s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("igns to redirect you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Most impo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("rtantly,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you can be found in sor")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("row by")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("becoming a different version of your")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("self, ")]), _c('br'), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("here, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("on the other side")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("tragedy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To: "), _c('br'), _vm._v("Bright ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Eyes, “Hit the Switch”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twelve")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("new beginnings")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" hav")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("e often spawned from "), _c('br'), _vm._v("forced endin")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("gs. With one of life’s chapters ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("being "), _c('br'), _vm._v("ripped from my hands before I")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" even had time to "), _c('br'), _vm._v("dog-ea")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("r my favorite parts. For a ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("very long time I "), _c('br'), _vm._v("confused the ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("notion of ")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("a fresh start")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" with w")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("alking "), _c('br'), _vm._v("toward distress inste")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ad of away from it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-36"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Now")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(", I relish the thought of ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-36"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("getting")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" to know the unknown. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-36"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Getting ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to familiarize")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-37"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("myself with the unfamili")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ar. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-37"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Getting to start over smack ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("dab ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-37"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("in the middle of my life ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-37"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("w")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("henever I damn well please.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Craig Mack feat. Notorious ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("B.I.G., LL Cool J,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“Flava in Ya ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ear (Remix)”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirteen")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("There has always been")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" a  d i s c o n n e c")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" t "), _c('br'), _vm._v("between me and the world")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" around me;"), _c('br'), _vm._v("I never felt settled, groun")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ded.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Suddenly, it became so ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("clear.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-38"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Perhaps I lost myself so ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("often because ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-38"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I found my san")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dy feet in a shore town.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("All ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my life, my footprints were ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("repeatedly")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" washed away by the tide,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" if I never existed there in the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" first place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ing To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Miranda Lambert, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Airstream Song")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fourteen")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Just because I don’t ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("trust you")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("\tdoesn’t mean I have trus")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t issues.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Just because I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" won’t commit to you")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("\tdoesn’t mean ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I have commitment issues.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Just be")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("cause I watch what I eat")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("\tdoesn’t ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("mean I have body image iss")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ues.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Just because people ha")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ve left my life")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("\tdoesn’t mean I have")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" abandonment issues.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Just ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("because I yearn to grow and evo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lve ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("doesn’t mean I have identity ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("issues.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I know exactly who ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the hell I am.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ing To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Chris Brown feat. An")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("dré 3000, Drake,"), _c('br'), _vm._v("Fabolous, Kanye West, T.I.")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(", “Deuces”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifteen")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("A picture never fully")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" captures "), _c('br'), _vm._v("the reasons behind")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" why I want "), _c('br'), _vm._v("to freeze the momen")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("t")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the first place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It doesn’t ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("capture the distant ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("smell ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of a fireplace burning as ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("’s quickly overtaken by the "), _c('br'), _vm._v("unmis")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("takable aroma of low tide.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-40"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It doesn’t ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("capture the cleansing ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-40"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sce")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nt of salt air entering my nos")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("trils. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-40"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It doesn’t capture")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" the monstrous ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-40"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("howl of the w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ind whipping through ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-40"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hair or the pleasurable")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sting ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of the sand in my eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-24"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It doesn’t capture the trans")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("formation ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-24"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the texture of the san")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d beneath ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-24"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my feet as I approach the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("breakers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It doesn’t capture the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("unexpected warmth")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of November’s ocean ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as it reaches my ankles.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lens of a camera cannot captur")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e any of that; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my heart does.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currentl")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("y Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lady Antebellum, “G")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("oodbye Town”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixteen")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("new normal")]), _c('span', {
    staticClass: "CharOverride-9"
  }), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("is rarely an easy adjustment")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" and "), _c('br'), _vm._v("never truly feels, well, ")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("norma")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("l")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Let’s be honest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Plan B")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" is")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" never preferred. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Detours and alterna")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("te routes ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("are never quite as scenic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-43"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("he darkness of being gifted ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a second chance ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-43"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("is that it mea")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ns something went")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-44"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wrong in the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" first place. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-44"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And yet,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("would rather have a few speed bumps slow ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("me")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("down, causing me to spill ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("coffee on my dress, than ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ever hand ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("someone else the keys to my")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-46"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Goo ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Goo Dolls, “Rebel Beat”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventeen")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Sometimes ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("you don’t realize "), _c('br'), _vm._v("you are  h o ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("l d i n g  yourself "), _c('br'), _vm._v("toget")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("her until")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-47"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-47"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("aren’t "), _c('br'), _vm._v("anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-48"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Suddenly, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you’re not the same "), _c('br'), _vm._v("person you thoug")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ht you were  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-48"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("j u s t     m o m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" e n t s    before.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-49"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("No.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-49"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("You are ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("not okay. "), _c('br'), _vm._v("You are not fine. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-49"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ut you will be.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("When I say, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("you will")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" be okay")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I do not mean ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you will wake up")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("one day and ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("be the same person ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you were ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("before the pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-49"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("\t          Pain changes")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" a person.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-51"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("But, you will dis")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("cover a "), _c('br'), _vm._v("new version of yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("One")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" who has experienced the great sadness")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that only follows a great loss.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("One who knows the")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("value of a good cry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("One who knows that even after")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the coldest of winters,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("spring will still arrive.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Eminem, “’Till I Collapse”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighteen")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("We cleanse our palates a")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("s midnight resets our "), _c('br'), _vm._v("lives. Clean slates al")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ways taste better when fizzy")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(". "), _c('br'), _vm._v("The unknown is easier digested when")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" fizzy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Frank Sinatra, “The Best Is")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Yet to Come”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Nineteen")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("There are")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lay")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("      ers")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("loving me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-54"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In the beginning, I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("am quite easy to love. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-54"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" surface is smooth, my smiles tend")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("er.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("But as time undresses,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-55"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my ins")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ides are revealed to be rough and")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ragged. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-55"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It will become awfully dif")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ficult to love me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("At times, borderline")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" impossible.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-56"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Many have left; for pe")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ople would rather ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-56"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("see a car acciden")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t unfold from afar, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-56"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("than be the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" shotgun rider.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Until you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Only ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you can see all you see, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("know all you know ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("about me,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" and still look at me lik")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("this")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Bright Eyes, “First Day of My Life”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("My lifelong person.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The man who")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" will help")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("zip my dress every m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("orning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("How do you do")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" it?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-57"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You fix everything ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-57"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("time and ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("time again ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-57"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("just by surviving")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" h r o u g h    the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("moment with me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Pearl Jam, “Jus")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("t Breathe”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty One")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("     If you are lucky eno")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ugh to have a childhood friend, t")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ry your hardest to grow old with th")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("em. These friends are a unique, ir")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("replaceable breed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("These friends")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" lived through curfews and Polaroid pict")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ures with you. These friends k")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("now your parents and siblings beca")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("use they had to call your hous")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e first to speak with you. Your ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("memories are not frozen in time on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" social media, but live on noneth")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eless.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Most importantly, they reme")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("mber the person you were befo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("re the world got ahold of you,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" so they have this crazy ability")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" to love you no matter wh")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("at.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("They are the living, breathing")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" reflection of where you have been. A")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nd so, just when you think")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" you’ve lost yourself for good,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" they are there to bring you")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" face-to-face with your tru")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e self, simply by sharing a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("cup of coffee with them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("As your")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" world grows and becomes larger")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" and more complicated than your bac")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("kyard, even if you establish a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("life elsewhere, I hope your childh")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ood friends remain lifelong allies, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("because mine have saved my life")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" on more than one occasion.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Be")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("atles, “With a Little Help fro")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("m My Friends”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty Two")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("2015")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I didn’t jus")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("t survive this year;")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I lived it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I l")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("aughed, I cried,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-63"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I scribbled th")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ings in journals.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-63"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My heart brok")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e, but kept ticking.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My pa")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ssport earned a few new stamps.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" had fancy Saturdays ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and lazy")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" Sundays.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I dipped my toes in tropical")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" seas.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I hiked mountains"), _c('br'), _vm._v("and cheated ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on my diet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-46"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I made my twent")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("y-ninth "), _c('br'), _vm._v("consecutive birthday ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wish.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Because of this, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and so much more, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" never settle on simply ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("surviving")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ever again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I choose to live.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("OneRepublic, “I ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lived”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty Three")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I want you to know,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" love you the other 364 day")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("All the commercially pop")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ular grand gestures in the  w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("orld could never compete with the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("millions of everyday little things yo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("u have done, and continue to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" do, for me. You continue to lov")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e me when I am, by definitio")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n, unlovable. You continue to love")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" me when I don’t particularly")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" love myself. You allow  m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e to remain my quirky self in ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a world that prefers conformity. I c")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an only hope I bring to you")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" the same feeling of completeness a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nd unconditional acceptance that you ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have given to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Love isn")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("’t about tangible things.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Love ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("has always been about two ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("people.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-65"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And since we are only ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("allotted one life per person,")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-65"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I feel undeniably privileged")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" and fortunate to get to ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-65"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("spend ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my one lifetime with you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Christina Perri, “Miles”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty Four")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("For the first time "), _c('br'), _vm._v("in month")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("s,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I didn’t wear a jacket")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on Sun")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I woke up and felt ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("differen")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("t")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Even before I cracked open my")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" windows, allowing ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("what ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("definitely resembled a spri")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ng breeze to creep ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("through and")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ruffle the loose papers on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my dresser. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Even before I heard")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" birds chirping and a seagu")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ll ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("cawing overhead. Even befor")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e the aroma of freshly")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ground coffee entered my nostril")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s, smelling more ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("like a p")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("leasure than a necessity.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" It was as if my soul ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("had tha")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wed. I felt completely reinvigorated.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Instead of wearing one o")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("f my seventeen pairs of black "), _c('br'), _vm._v("y")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("oga pants I had been wearing si")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nce October, I opted "), _c('br'), _vm._v("for an olive green ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("maxi dress and a light cardigan")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Others felt the change, too. I not")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("iced some girls in ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("flip-flops")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" hopscotching through puddles ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of melting snow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Call it ridiculous,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" but there was an upswing in")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("mood, just at the mere pro")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("mise of spring.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-67"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Perhaps my deci")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sion to nix the jacket was a s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ymbol ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-67"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for change, not just in")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" the weather, but within ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-67"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("myse")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lf.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I caught a glimpse of ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the girl I had been missing "), _c('br'), _vm._v("greatly")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" the last couple of months. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It was nice to see "), _c('br'), _vm._v("her again")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("So Sunday, I sang alon")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g with the radio really loudly "), _c('br'), _vm._v("and u")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("napologetically, I drank thr")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ee mimosas before ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("one o’clock, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and I didn’t wear a jacket.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currentl")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("y Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Kendrick Lamar, “Bi")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("tch, Don’t Kill My Vibe”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty Five")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am never going to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" be the girl with the perfectly "), _c('br'), _vm._v("s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("traightened hair or creased clothin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g. Even at my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("most put together,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I’ll look a bit    d i s h e")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" v e l e d.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My socks will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" never match, but no one will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" notice ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that except for my lo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ver and airport security. At")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the most inopportune times, I’ll have ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a run in my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("stocking or a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" runny nose.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I’ll combine foods ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("even a pregnant woman ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("wouldn’t")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" crave. On way more than one oc")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("casion, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("my friends have said")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" out loud,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" I would not want")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" to")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("spend one minute in your head.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-71"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" was always aware of what")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I encompassed. I have ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-71"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("never tried ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to conform because I did not")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" feel the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-71"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("pressure to do ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("so ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("(thanks, Mom!).")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" Yes, t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("his self- ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-71"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("assurance led to my gr")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ade school years being a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-71"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("livin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g hell, but even then I recog")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nized that time  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-71"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of my life as")]), _c('span', {
    staticClass: "CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("temporary")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I do not fear, nor ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("am I ashamed of, myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("As lon")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g as I am happy, it is my ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("God-given right "), _c('br'), _vm._v("to be odd. To")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" be my true self.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currentl")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("y Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Taylor")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Swift, “Mean”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty Six")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-72"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The way you peer "), _c('br'), _vm._v("in")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to my depths ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-72"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("with such ease, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-72"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" soul must")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have a glass bottom.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-73"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("embrace ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-73"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my complexity")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-74"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and bravely")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" swim ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-74"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("against my current.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-75"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You do not fear the pull o")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("f ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-75"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my murky undertow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You vo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("w")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" forever")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" to me ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as if it were")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" as simple as")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("slipping a ring upon m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("y finger")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("because, maybe this time,")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" it")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" is.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-75"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-75"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ed Sheeran,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" “Tenerife Sea”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty Seven")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Sometimes it hurts ")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("to breathe.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My corrupt decisions")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("weigh on my chest,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-76"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("methodically")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" pushing down ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-76"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to crack each")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" rib,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in hopes of infiltrating")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-77"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my heart and ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("finally exterminating ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-77"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the last shr")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ed of the human being  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-77"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I once w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("If that happens,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-78"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("if my sanctuary is")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" breached, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-78"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I will not stand")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" a chance.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I will lose the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("one last single atom ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that makes")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" me, ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("me")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I can’t lose me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I’m ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("all I’ve got.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-79"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-79"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("upac, “Keep Ya Head Up”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty Eight")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Growin")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("g up, my mother cautioned I w")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ould "), _c('br'), _vm._v("not possess the power to plan")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" out my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I couldn’t say,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-80"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I’ll ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("be married by X, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-80"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("have a kid by Y,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("have")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" a book out by Z.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I was told ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as much as I crave to trea")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t my life as one ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("big to-do")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" list, I would instead find m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("yself asking, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Where from here?")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t least a few times in m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("y life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Now, I catch myself")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" asking this a few times a d")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ay.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Where from here?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Three pin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t-sized words shouldn’t be able to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" pose ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("such a fatal and fi")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nal question, but alas, they ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("do. If ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you go right, you can’t go")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" left. Even if you ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("backpedal to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" take the other route just a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" second ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("later, your fate will already ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("be altered. It’s this or ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that, never both. It")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" is a hard pill for me to ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("swa")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("llow, but I do believe it ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("is in the navigation ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that you find")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" your way, and inevitably")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("find you")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("rself.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening T")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("o:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Miranda Lambert, “Mama, I’m Alright”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Twenty Nine")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I carry you with me all ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("of the time, "), _c('br'), _vm._v("but I feel your abs")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ence most on the "), _c('br'), _vm._v("days when")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" I’m the happiest.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-81"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not when I ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("need")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" you here the most, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-81"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("when I ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("want")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" you here the mos")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I believe grief is like a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("shadow. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s always there, it ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("follows")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you everywhere you go, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but you only see it when")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-83"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" sun is shining on a beaut")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("iful day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-84"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-85"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Band Perry, “If I Die You")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ng”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("A change in the season "), _c('br')]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("always ignited a change "), _c('br'), _vm._v("in ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("your heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-86"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I became angry ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("with the Universe ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-86"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("its natural transitions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I c")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ame to fear")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("our altered rhythm;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the su")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("btle shifts")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-51"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in both your affection ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-51"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and in the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" air.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-88"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Seasons ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-88"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-88"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("patterns.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("You’d be back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-89"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And like win")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ter’s "), _c('br'), _vm._v("losing fight ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-89"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("against s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("pring,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I’d thaw.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("G")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("riffin House, “Tell Me a Lie”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty One")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("EWR to BNA")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The ride to the airport is alw")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ays too short.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Even if I’m pac")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ked for days, I’m never ready")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" to go. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A nervous feeling inhabits ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my stomach right before ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my feet ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hit the hectic curb.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I che")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ck my bag and then head up ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to security. The ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("line is lon")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g as the employee asks, ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Are you")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" alone?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("(In life or just right no")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("w?)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-90"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("He points me in the direction a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("way from ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-90"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the lovers and families tr")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("aveling together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-91"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The person in f")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ront of me doesn’t have to ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-91"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("remove thei")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("r shoes but I do (")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("of cou")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("rse")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(")  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-91"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("so now I’m barefoot in Ne")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wark Airport.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I make it to the ga")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("te")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and immediately insert my headphones")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-92"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("That doesn’t stop the Chatty Cath")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("y beside me ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-92"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("from asking, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("So")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(", where are you coming from?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("(Don’t y")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ou mean, “What are you runn")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ing from?”)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-67"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Pretending she star")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("tled me, I remove my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-67"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("headphones. She")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" repeats the question.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("(How spec")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ific do you want me to get? I")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("’m coming "), _c('br'), _vm._v("from therapy. I’m coming ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("from a weekend of binge"), _c('br'), _vm._v("drinki")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ng. I’m coming from a s")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("leepless night due to "), _c('br'), _vm._v("a migraine I’m still fe")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("eling.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-93"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I answer, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("New Jersey.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-94"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ve")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" always preferred the more hopeful,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-95"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Where are you heading?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-96"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My answer?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-97"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Everywhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Brand New, “Okay, I Believe You, but My Tommy Gun Don’t”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty Two")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("There have been")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" nights")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-63"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ve shared a twin bed w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ith him ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-63"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and still couldn’t get ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("close enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Then there have b")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("een nights ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("spent in a king bed wh")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ere I’ve felt")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as though his annoying")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ass was still ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-25"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in my perso")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nal space.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We    e b b    and    f ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("l o w.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("But there’s no one else I’d rather ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("crash i")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nto every night when")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the tide hits its i")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nevitable peak.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-99"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-99"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Des’")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ree, “I’m Kissing You")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty Three")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-100"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I feel at peace the nights ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-100"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I find myself naked ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-100"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("beneath our s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("heets.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I stare at the ceiling")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-91"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and I create my own co")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nstellations ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-91"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("from its paint cracks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-26"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" feel more connected to the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Universe ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-26"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("during the moments we ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("spend together ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-26"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("under our artificial pla")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ster sky")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-101"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("than I ever could on evenings")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" spent ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-101"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("outside, with the starr")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("y night sky,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-102"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("counting actual ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-102"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("co")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nstellations")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("without you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Andrew McMahon ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("in the Wilderness, “Cecilia an")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("d the Satellite")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty Four")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Not laugh")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ing for fear of crying. "), _c('br'), _vm._v("Not")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" loving for fear of heart")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("break.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not choosing for fear ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of wrong decisions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-103"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not dreaming for f")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ear of nightmares. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-103"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not trus")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ting for fear of betray")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("al.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not jumping for fear of ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("broken bones.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not exploring for fear")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" of getting lost.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not attempting for")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" fear of failing ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("is like n")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ot living for fear of dyin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It is impossible to escape this w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("orld unscathed. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("So, embrace this")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("    m e s s y,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("un        certain        existence")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("nd live.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Kacey Musgraves, “Somebody to L")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ove”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty Five")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I’m not the one who got")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Late nights and lonelin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ess ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have built me up in your head.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Letting go of even the wrong he")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("art ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("can play tricks on one’s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" mind, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("confusing two souls ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("once mated for soul mates.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("So")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(", please, the next time")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-105"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the smell ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of Chanel fills up a room")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-105"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and you find yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("reminded of ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("me, remember:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I never even wore pe")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("rfume.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-76"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Nancy Sina")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("tra, “Bang Bang (My Baby Shot Me Down)”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty Six")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I fin")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("d comfort")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the colors of a s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("unset.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-106"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I find a special mag")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ic ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-106"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the fact")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it never photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-107"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as be")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("autifully as my eyes ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-107"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("can wit")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ness it firsthand.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-108"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I find a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" certain peace ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-108"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the conclusion ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of "), _c('br'), _vm._v("another day lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("find hope")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-109"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the precarious promise")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-109"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of tomorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently List")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lee Ann Womack, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“I Hope You Dance”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty Seven")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-110"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Four children")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" sit together in a room, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-110"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("f")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("orming a square.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-111"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In the center is a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" deck of cards. Brand new")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-111"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Together, using all fifty-two, t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hey construct a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-111"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("house of ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("cards.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("They revel at their ma")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sterpiece for all of two ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("minutes,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" as one of their mothers enters")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" the room. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Believing it to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("be muggy, she opens the wi")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ndow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-112"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A gust of wind enters")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" and blows ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-112"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the cards in different direction")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Annoyed a tornado des")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("troyed their work in mere ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("second")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s, one child storms out of ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the room, leaving ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the door open.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" The three remaining child")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ren ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("decide to start over.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-113"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Card by card the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" house is reassembled. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-113"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Immediately")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" following, the family’s puppy")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-113"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("charges into the room through the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" opened door ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-113"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and plows in")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to the house of cards like a")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-113"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wrecking ball through cement.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-113"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Another one of the children runs out in tears.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-113"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The remaining two children once again collect the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-114"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("fifty-two cards and begin to form the foundation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And just as the final")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" card is placed on top, "), _c('br'), _vm._v("the mother reappea")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("rs and swings the "), _c('br'), _vm._v("playroom doo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("r closed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Though brief, the s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("udden, manufactured airstream ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("caus")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("es the house to collapse ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for the third time just ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the door slams shut.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-112"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("This setb")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ack causes another child ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-112"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to march out of ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A single child be")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("gins gathering the cards.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("er mother comes in and asks ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("why she is playing ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("alone when a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ll her friends are outside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-23"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Without even ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("a hesitation, the child respond")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("s, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-23"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("If I still have the pieces,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" why wouldn’t I keep ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-23"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("rebuildi")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ng?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-17"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Eminem, “Solid")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("er”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty Eight")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("No matter how old I become, a s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("light sadness ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("always washes")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" over me moments before I drive")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("away from the home where I grew ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Feelings of melancholy enter the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" pit of my stomach ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as though ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am saying goodbye to a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dear friend. I ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("stand at")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" the curb soaking in the last mome")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nts of ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hearing my mother’s wind")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" chimes sway in the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("autumnal air.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("is likely I will live in a f")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ew different houses ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("throughout")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my life, but I believe there will alw")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ays ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("only be one ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("home")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-116"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" home where memories have seeped deep ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("into ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-116"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the paint and pillows; w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("here unconditional love ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-116"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("travels ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("around the house as if it w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ere another ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-116"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("member of the family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sanctuary where pictures, uncha")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nged for years, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hang on ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the wall as reminders of")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" who I used to be ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and how ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("far I have come.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("There is someth")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ing different about the breeze that")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("passes through the windows")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" of my parents’ home; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it somehow")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" holds the power to wrap around")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" me ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and rock me until I drift of")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("f to sleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("That cozy secur")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ity felt by sharing a bedroom wall "), _c('br'), _vm._v("with my")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" sister. There’s something reass")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("uring "), _c('br'), _vm._v("about seeing my mother’s purse")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" slung over a "), _c('br'), _vm._v("kitchen chair")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" or my father’s shoes")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("by the front do")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("or.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-65"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In a world where so m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("any unfamiliar variables can ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-65"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("arise")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" out of nowhere, it is a com")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("fort to have a very ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-65"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("familiar constant.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Home:")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" where love and support ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("concurrently ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("grounded me and encoura")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ged me to fly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Carrie Underwood, “Don’t ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Forget to Remember Me”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Thirty Nine")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I was")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" running errands the day")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" I received the worst "), _c('br'), _vm._v("news")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" of my life. I got the phone c")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("all in Target’s "), _c('br'), _vm._v("parking lot, hung up, g")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ot out of my car, puked ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("on "), _c('br'), _vm._v("the side of my tire, and s")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("till walked into the store "), _c('br')]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("to buy the birthday card I ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("needed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-118"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Now, in the past, I ha")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ve cried hysterically from ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-118"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("happine")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ss. I have laughed uncontrolla")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("bly out of ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-118"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("immense anger. And I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have been so overly tired ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-118"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I was unable to sleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("But as ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the red-vested cashier asked the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("usual,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("How are you today?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I re")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sponded,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fine, thanks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And somehow")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("I even manage")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("d to smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Liste")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ning To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Twenty One Pilots, “S")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("tressed Out”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("There are days I spill")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" coffee")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("all over the passenger s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eat before 7 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Days I f")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("orget to pay bills")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("or respond to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" wedding invitations.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-119"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Days I am")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" overwhelmingly sad ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-119"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for reasons")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I cannot pinpoint.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-120"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Days I will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" no doubt attempt to pull ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-120"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a door")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" clearly marked ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Push")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-121"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Most days ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I find myself stumbling ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-121"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("over ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("flat surfaces and expectatio")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ns.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-86"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yet, I know you will ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("love me the same, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-86"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and that a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lone makes my daily ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-86"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("missteps l")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ess catastrophic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-122"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Eternally")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" Grateful, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-122"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Your Hot Mess")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Sublime,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" “Waiting  for  My  Ruca”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty One")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("A me")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ssage from the Universe a")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ppeared "), _c('br'), _vm._v("in the form of a hand")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("written note taped "), _c('br'), _vm._v("to the wall o")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("f a nail salon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("\t\tWe are not")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" responsible for your loss.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I knew the makeshift sign simply ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("forewarned if I ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("left behin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d one of my possessions ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it was my fault, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("not theirs.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" Yet, I took it to mean mo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("re, as if the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("world was s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("haking me awake.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("\t\tI need to stop ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("making excuses.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-55"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I need to stop ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("placing blame. I need to stop ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-55"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("r")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("enaming the decisions I’ve made as")]), _c('span', {
    staticClass: "CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("mistakes")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" just ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-55"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("because I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wish I could take them bac")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("k.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Jay Z ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("feat. Justin Timberlake, “Holy Grail”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty Two")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I never wanted to help you")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_c('br'), _vm._v("with your problems "), _c('br'), _vm._v("because I a")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("m selfish.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-99"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I knew if I w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ere to let you go, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-99"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that alone would")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" solve")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("every single issue in yo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ur life, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and I just wasn’t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ready")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to leave you yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-99"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-99"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Rita Ora, “Been Lying”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty Three")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("See")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v(" you later, Cuz.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The last words ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my cousin ever said to me. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Last")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" words.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("What an unusual concept.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-40"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We rarely ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("know they are the last "), _c('br'), _vm._v("as t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hey leave lips.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-126"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Though it was a da")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("rk time, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-126"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am certain she believed ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-126"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in h")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("er last words to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-127"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am certain")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" she believed ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-127"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("there would be another")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Her last words were a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("promise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And though, yes, we will never")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("see")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" each other again in the ph")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ysical,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-128"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I do believe I see my cousin a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ll around me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In dusty Emerson books")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d in old Broadway ticket stubs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-129"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In magazines we used to thumb throu")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("gh. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("In her mother’s laugh."), _c('br'), _vm._v("In an eye roll after hearing"), _c('br'), _vm._v("her father’s latest joke."), _c('br'), _vm._v("In a drive by a lake.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("In yellowed photographs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("In the steep hill of her front lawn.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In shopping for CDs")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and cheesy San")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dra Bullock movies.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-130"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In ponytails and black")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" hoodies. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-130"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In the title song from ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Rent.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In sushi ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dinners in New York City.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In Christmas ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("mornings ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-58"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and sarcastic remarks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("In an")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" order of buffalo fries (")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("extra spicy")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("In Goo G")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("oo Dolls song lyrics.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("most importantly, in my heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-90"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I u")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("se my words as a vessel to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("reach her. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-90"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("To stay connected ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("To keep her connected to us.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("To")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" hold up my end of our promise.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I will")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" see you later, Cuz. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Currently ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Listening T")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("o:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Cast of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Rent, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“Seasons of Love”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty Four")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The sand beneath my feet ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("     belongs ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to September now.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The salt air ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I inhale")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("     belongs to September no")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("w.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The crashing waves")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("     belong to Septem")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ber now.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-132"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("August can have ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-132"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my y")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("esterdays; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-132"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my tomorrows")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("     belong to September now.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my heart")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent ParaOverride-70"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("     belongs to September now")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Don He")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("nley, “The Boys of Summer”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty Five")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Dedicated to Kellie.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Si")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sters can have very little in common")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(". No shared "), _c('br'), _vm._v("interests or frien")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ds or aspirations. The mos")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t my "), _c('br'), _vm._v("sister and I have in c")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ommon most days are our "), _c('br'), _vm._v("blue eyes,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" parents, and my clothes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yet, w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e are tethered together, unfailingly")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s one thing to have a suppo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("rt system in your life "), _c('br'), _vm._v("to ch")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eer you on during the instances ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("when "), _c('br'), _vm._v("everyone is rooting for")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" you. However, it’s another "), _c('br'), _vm._v("thing entirely ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to look back in your darkest "), _c('br')]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("moments and still see them standing ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in your "), _c('br'), _vm._v("corner, encouraging you to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("stay in the ring and "), _c('br'), _vm._v("FIGHT")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(", when the odds aren’t in your ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("favor and all "), _c('br'), _vm._v("you want to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("do is throw in the towel.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not many people in this life will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" be on your side "), _c('br'), _vm._v("even when they ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("aren’t on your side. Even less who "), _c('br')]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("momentarily will slam doors out o")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("f frustration but "), _c('br'), _vm._v("never actually lock")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" you out.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-134"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Unconditional love; the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("definition of ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("sister")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-134"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-135"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Irving Berlin, “Sisters”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty Six")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Packing up your belongings means")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" nothing")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("if you can’t box up your")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" heart, scribble ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("fragile")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("along the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" side, and take it with you,")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-90"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s hard to walk away, eve")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n if you know ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-90"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in your heart of")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" hearts it’s necessary.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-136"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Even if y")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("our feet can’t do the job ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-136"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and you")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" find yourself crawling on ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-136"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("your han")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ds and knees away")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("from a toxic")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" situation,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2",
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("\tbe proud of yourself. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You are removing yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to better yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-138"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and you will st")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-138"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on your own two feet")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_c('br'), _vm._v("again eventually.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("So crawl, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("walk, or run;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("\tthe ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("how")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" doesn’t matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-Indent ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Your n")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ew life is waiting for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-87"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Eric Churc")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("h, “Give Me Back My Hometown”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty Seven")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("This drugstore lipstick")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-139"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("is doing a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" poor job at covering ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-139"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my chapped, bit")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ten lips.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My sunglasses")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("are doing ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("their best to hide")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the dark c")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ircles surrounding my light eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-120"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Would the wind feel this co")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ld today ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-120"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("if you were still here?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I think back to the last r")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eal day we spent together; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("there")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" was nothing special about it. It")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" was rushed, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and I remember")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" the coffee tasting bitter. It’s o")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nly ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("special now because it w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as our last.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-140"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Though I wish ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("we had traded ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-140"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("everlasting la")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("st words, we didn’t. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-140"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("And we")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" won’t.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-141"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("However, now when I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have a cup  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-141"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of bad coffee, it will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" taste less bitter")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and more ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sweet. I will smile and savor")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" it,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("like the last real day ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("we shared together.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-126"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening T")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("o:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-126"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lea Michele, “If You Say So”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty Eight")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" was the kind of kid "), _c('br'), _vm._v("who would")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" step on ants "), _c('br'), _vm._v("and then as")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("k my mother "), _c('br'), _vm._v("if their family")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("would ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("miss them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("When I was ten,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-142"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I begged ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my parents ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-142"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for a typewriter")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-143"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d then had my father ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-143"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("show me how to")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dra")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ft a professional r")]), _c('span', {
    staticClass: "CharOverride-5",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("é")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sumé.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("When ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I was eleven,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I coerced my siblings")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d cousins")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to perform skits")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and lip-synch ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in music videos ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I filmed with")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the family")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" camcorder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("When I was thirteen,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-144"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ould spend hours "), _c('br'), _vm._v("after school writing "), _c('br'), _vm._v("origin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("al stories ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-144"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("using the charac")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ters")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("from ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Buffy the Vampire Slayer")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and the members of")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the Backstreet Boys.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I had no idea ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("it was called")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("fan fiction")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" at the time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I was a witch")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-99"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for H")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("alloween six times; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-99"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("not beca")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("use")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I lacked creativity,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but becaus")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-146"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I desperately wanted ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-146"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to be a w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("itch.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Like,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" for real")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("One da")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("y,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-102"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my uncle looked at me ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-102"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("aid,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("You’re a lonely soul, man.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" possible,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I suppose.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I studied En")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("glish")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in a Catholic women’s coll")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ege ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and, for my senior the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sis,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("rewrote ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Alice in Wo")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("nderland")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("from the White Rabbit’s per")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("spective.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-46"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I also explored in writin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-147"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the idea of Anna Karenina")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("being pushed under the carriage ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("of that passing train")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("against her will.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("My professor told me")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I didn’t listen to")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the essay instructions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" got the paper back")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and saw that I e")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("arned an ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" anyway")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("with a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" note saying,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-24"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Alicia, thou")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("gh you blatantly ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-24"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ignored the pro")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("mpt, after reading ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-24"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("this succinct conspiracy theory")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I can see the original essa")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("y topic ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("would have bored you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-148"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Does your brain ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-148"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ever slow down")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("No.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ca")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ge the Elephant, “In One ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ear”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Forty Nine")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I love the way your tongue ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("curls when")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-118"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you are about to sne")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eze. I love that you don’t ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-118"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sit")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" on the same side of the booth")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" as me when ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-118"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("we are out to dinn")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("er. I love how you pretend ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-118"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to no")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("tice my manicure.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-75"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And I love ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that I cannot ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-75"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("define the word ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("love")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-75"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("without saying your name.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Anytime")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I am anywhere,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I wish you w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ere beside me ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("because I am unab")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("le to separate ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my life from your")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Which leads me to believe")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" you are my life, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and my life is ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you;")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("they are one and the same")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-150"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-150"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Cast of")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Wicked, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“For Good”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The shore is always f")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("orgiving of the sea, "), _c('br'), _vm._v("though they me")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("rge together"), _c('br'), _vm._v("time and time again on")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ly to part.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-151"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The sea always ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("returns to kiss the shore, "), _c('br'), _vm._v("for both")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" hold the innate understanding")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_c('br'), _vm._v("that one cannot exist without")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("We forgive each other for ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("the very same reason.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Emeli Sand")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("é")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(", “R")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ead All About It (Part III)”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty One")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" wear my yesterdays.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-152"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yesterday’s hair. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-152"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yesterday’s clothes. "), _c('br'), _vm._v("Yesterday’s makeup.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("You.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My yesterdays are familiar but each day")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" they ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("become more wrinkled, worn, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and stained ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and bring me less c")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("omfort. My past is")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("beginning to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" feel tight around my neck—")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("itch")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("y")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I like to believe I am outgrow")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ing who I was ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and what")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I needed when I was that pers")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-153"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I like to think I will s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hed all of this, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-153"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("even the skin you’ve touched.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("It’s")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" nice to think about.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ingrid Micha")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("elson, “Hell No”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty Two")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("It’s commonplace")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-154"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to ramble off ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I lost myself,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-155"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("when you ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("go off course.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s the perfect excuse,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-156"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("one that allow")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s you to admit fault")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-157"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("while simultaneously remaini")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ng the victim.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I admit I’ve even said it ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("after I fuc")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ked up")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-109"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("beyond a simple apology ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-109"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and had")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" to look my")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-158"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("collateral damage in th")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-84"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Is that bullshit though?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-159"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Did")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I lose myself or just los")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e focus? ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-159"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Did I become selfish,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-160"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("even but")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" for a moment, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-160"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and destroy something?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-91"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Perhaps we give so much of ourselves ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-91"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("way that we feel like essential pie")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ces ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-91"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of ourselves go missing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-84"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We give")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ourselves away")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-161"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to our past regrets and")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" present aspirations,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-67"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to missed opportunities and")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" everyday miracles,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to lovers and ex-lovers,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to harsh realities and unattainable daydreams,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to lost childhoods and ill-prepared adulthoods,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to flat tires and missed trains,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to friends and enemies,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" happy birthdays and hungover mornings")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(", ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to families and their fallen ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("faces")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-162"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("when we let them down, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-162"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("fall festivities,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("winter wonderla")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nds,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-163"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sprung springs, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-163"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and summer")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" suns.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I do not believe we lose")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ourselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-31"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’d like to think we w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ould never lose ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-31"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("something so ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("precious if we could help it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("That, my ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("friends,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-164"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I think life steals from")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" us ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-164"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("from time to time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Mumford & S")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ons, “Little Lion Man”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty Three")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("My brain is")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2",
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("    a l l")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text",
    staticStyle: {
      "text-indent": "3em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("         o v e r")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text",
    staticStyle: {
      "text-indent": "6em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("                   the         place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Grief")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("will do that to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-134"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Today I sat in")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my car in my own driveway ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-134"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" twenty minutes staring blankly")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-165"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("at my g")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("love compartment. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-165"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("My mind    d r ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("i f t e d    o f f. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-165"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Grief")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("will do t")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("hat to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I found myself won")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dering why we still call t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("his")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("thing a “glove compartment” when no")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" one keeps ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("driving gloves, or an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("y gloves for that matter, in ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("there anymor")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("As a society, we are al")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ways talking about ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("progression. We are r")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("enaming TV stations and ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("street names")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—but can’t rename this storage box ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("within our cars.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Don’t fix what")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ain’t broken, I guess.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Something")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" broke me, and I need to be")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" fixed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Grief")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("will do that to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("What else would")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" we call it?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-103"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Crumpled tissue holde")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("r. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-103"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Registration and insurance ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("safe.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-166"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I question everything now, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-166"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("even things that don’t matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Grief")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("will ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("do that to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-167"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listeni")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ng To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-167"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lynyrd Skynyrd, “F")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ree Bird”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty Four")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("One daybreak I woke ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("to the aftermath of a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("surprise sno")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wstorm. It was one of those s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("torms ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that visit overnight when you leas")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t expect it, like ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the midd")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("le of March even though the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" weather ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("has warmed and you’ve stopped weari")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ng a coat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("There was a lot of ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("snow,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but the plows had arrived already.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I g")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("uess it wasn’t as unexpected as I thought")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I got in my car and beg")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an my commute to work. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It takes me")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" through a park. That morning the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("park")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" was blanketed in virgin snow. The")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" bare ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("trees wore the flakes like diamon")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d earrings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-168"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Everything was clean a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nd beautiful, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-168"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("white and pure.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It reminded ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("me of snow days spent home from ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("schoo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("l. It reminded me of the fifteen")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" minutes it ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("took to suit up before")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" going outside. It reminded ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("me of snow a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ngels and snow-adorned railroad ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("track")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s. It reminded me of the chill")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" felt when ice ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("would sneak inside ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my glove and shock my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wris")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t. It reminded me of my mother layin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g our ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wet clothes on the radiators")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" to dry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I urged myself to pull over ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and take a picture of "), _c('br'), _vm._v("the beauty")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(". That’s how much the vision moved "), _c('br'), _vm._v("me. I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wanted to stop and capture the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("scene; but I "), _c('br'), _vm._v("didn’t. I was already d")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("riving too slow to make it "), _c('br'), _vm._v("to work ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on time so I just kept driving. T")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("he adult "), _c('br'), _vm._v("in me had won over my ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("inner child. I promised "), _c('br'), _vm._v("myself ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I would take a picture on my ride b")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ack "), _c('br'), _vm._v("home—back through the same par")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("k.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("As I sat at my desk that")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" day, the temperature ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("crept up and I watc")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hed the snow melt. I felt sad.")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("By the time I was driving back ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("through the park, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("everything was")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" brown and dry again—litter was ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("exposed")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—all the beauty had melted aw")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ay. I ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("should have stopped all of three secon")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ds to take ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that damn picture. Who kn")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ows if I will see a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("winter")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" wonderland like that again in my")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" lifetime.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-169"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Thirty years old and I still")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" think a moment will ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-169"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wait for me")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" to catch up.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ing To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Albert Hammond Jr.")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(", “Feed Me Jack”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty Five")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-103"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I spent a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lot of my early twenties ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-103"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("making m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("istakes;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("really bad ones.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The lig")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ht of day was not my friend;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("as tired of how it illuminated")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my missteps.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-54"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I began plucki")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ng away at my blessings ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-54"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lik")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e stars from the sky")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("just so my w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("orld could go black.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-166"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Enlightenment ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("was something ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-166"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I bumped into in ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the dark,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("like a corner of a table ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("or lamp.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Isolating yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("does not make you unique,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("it ma")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("kes you a coward,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("too afraid or ashamed")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("to show up for your own life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-46"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I decided a long time ago ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-46"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to stop exclusively chasing ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-46"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my vis")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ions just when")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my head was on a pil")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("low.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I decided a long time")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ago")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to be better off in the da")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ylight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-170"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("To do better, "), _c('br'), _vm._v("to be better, "), _c('br'), _vm._v("to make ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("other "), _c('br'), _vm._v("things better.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-171"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My whole damn life ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-171"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("is my passion project.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You think ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I have big hair; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you should see my dr")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eams.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Jordin Sparks, “This Is My ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Now”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty Six")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-90"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("What is the difference between Earth ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-90"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" the World?")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" I asked my fourth grade ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-90"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("teacher")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" whose name escapes me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-172"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("She seemed ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to be using ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-172"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the terms interchangeably.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-173"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Since, right now, "), _c('br'), _vm._v("humans only live "), _c('br'), _vm._v("here")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" on Earth,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-57"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the two words mean")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-57"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the same thin")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("g,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("she answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("As years went on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(", I found the two words to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" be ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("vastly different. Earth is the pla")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("net we inhabit, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("yes, but the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" World is a unique plane of e")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("xistence ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to each person. As w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e plant roots and find love ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d birth babies and become reg")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ulars at coffee ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("shops and restaurants,")]), _c('span', {
    staticClass: "CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("the World")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" quickly ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("becomes ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Our Wor")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ld")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("; mini colonies.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ve found that certain ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("worlds can become as "), _c('br'), _vm._v("narrow as hallw")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ays; and these passages I walk ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("through, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the worlds I know, can")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("begin to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" feel constrictive.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The truth is, I’ve outg")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("rown many worlds on "), _c('br'), _vm._v("Planet Earth, ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("only to begin again. ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Earth")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" provides "), _c('br')]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the air we need to fill our lung")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s, but ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Our Worlds")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_c('br'), _vm._v("give us every ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("reason to breathe deep. We must")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_c('br'), _vm._v("not take anything for granted on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" the exhale.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Andy Grammer, “Back Home”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty Seven")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("This mirror")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" holds all my secrets; "), _c('br'), _vm._v("my hopes and ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("fears are mixed "), _c('br'), _vm._v("with the toothpaste")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" spatter")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I keep forgetting to wi")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("pe away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-86"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It sees me at my most ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("vulnerable, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-86"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("crusty eyed and naked face.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" am forced to face it each day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("You do not")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" have it all together,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I write in th")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e steam,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("knowing it will disappear.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I realize that this may be")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the mos")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t honest I will be all day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("urrently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Mike Po")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("sner, “Be As You Are”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty Eight")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Your teeth ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("will begin to chatter. "), _c('br'), _vm._v("Your fingertips")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" will turn blue.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Your lips will chap a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nd your eyes will tear.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-51"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You will w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("onder why "), _c('br'), _vm._v("you just can’t shake ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-51"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that penetrating")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" chill ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-51"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("within your bones.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-175"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("It is bec")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ause ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-175"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("my warmth ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-175"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("left your heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listeni")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ng To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ZZ Ward, “365 Days”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Fifty Nine")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I want a busy kitchen, with ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("small fingerprint "), _c('br'), _vm._v("smudges on the refr")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("igerator door. I want a "), _c('br'), _vm._v("crow")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ded bed where all nightmares disappear. I "), _c('br'), _vm._v("want ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("to jump in a cold pool or ocean an")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("d still "), _c('br'), _vm._v("smile. I want early Ch")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ristmas mornings, with "), _c('br'), _vm._v("stocki")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ngs held by the chimney with ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("care and "), _c('br'), _vm._v("little voices whispering ")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Santa")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v(" came!")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" I want to be "), _c('br'), _vm._v("a thirt")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("y-something-year-old in a ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("pointy cardboard "), _c('br'), _vm._v("birthday hat. I want m")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("y homemade chicken "), _c('br'), _vm._v("noodle soup to cure")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" colds and my Band-Aid "), _c('br'), _vm._v("kisses")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" to heal knee scrapes. I want")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" to freeze "), _c('br'), _vm._v("moments in cement. I w")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ant to learn to swim "), _c('br'), _vm._v("again, skip ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("through sprinklers again, welcome "), _c('br'), _vm._v("the tooth fairy ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("again, and make sand castles")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_c('br'), _vm._v("again. I want to believe in magic")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I want to be born again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("urrently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Waitress")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the Musical, “Everything ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Changes”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The letters behind ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("the cursor are already in the "), _c('br'), _vm._v("past. ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("That’s how fast it all happens. A finite twenty-six")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_c('br'), _vm._v("letters create an infinite trail of breadc")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("rumbs "), _c('br'), _vm._v("that lead to different moments")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" that lead to who "), _c('br'), _vm._v("I was just a")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" moment before.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-160"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am no longer the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" person "), _c('br'), _vm._v("I was just a twinkling")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-176"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The changes are so minute, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-176"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" they are there—")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you may think you")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" remain")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the same person you were")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a day ago,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-132",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("   an hour ago, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-132",
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("      a page ago,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-150",
    staticStyle: {
      "text-indent": "3em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("         a      line        break        ago,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("but")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" you are not.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Wrabel, “11 Blocks”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty One")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Maybe")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" you’ve gone through something "), _c('br'), _vm._v("n")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("o one should have to go throug")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("h"), _c('br'), _vm._v("at such a young age.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Maybe you kn")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ow the pain ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of a loss so deep,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("your")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" marrow aches.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not many know the a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nguish felt in")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("growing older ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("than your older sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Having her ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("laugh stolen from you")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("in the middle")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" of a joke.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Talking in past tense.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-177"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Everythin")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("g will be in ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-177"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("past tense from now on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Maybe you know what it is lik")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to wake up from slumber, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("covered i")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n your own tears.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Maybe e")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ach pump of your heart hurts")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("your chest, b")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ut your heart pumps, even still.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-176"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("This pain")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" is reminding you ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-176"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that you are ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("alive.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("There is an empowerment "), _c('br'), _vm._v("uncorked i")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n grief.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-27"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Your life will never be the same, ever, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-27"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("so you can never be the same, ever.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Pain will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" make you stronger, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but it will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" make you a lot")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of other things f")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("irst.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-108"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Maybe at its worst, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-108"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("will cripple you;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-179"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but, maybe, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-179"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("at ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("its best,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-180"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it will become ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-180"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("your superpower.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Queen,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" “We Are the Champions”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty Two")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Growth or a change "), _c('br'), _vm._v("in my perspec")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("tive")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("will turn some people off,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("turn some people")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" away.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("This doesn’t mean")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am growing i")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n the wrong direction.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s important to remember")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("no o")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ne needs to be in my corner")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("as ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("long as I am in my corner.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("No on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e needs to witness my comeback;")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("what matters is I come back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-181"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("This is not a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" classic underdog story; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-181"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am not ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a phoenix.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I did not rise from t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("he ashes—")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I crawled out from und")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("er the soot,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-109"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("fingernails cracked, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-109"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("pal")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ms bloody,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("face muddy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I told you I’d be okay on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Today is that day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ben Rector, “M")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ake Something Beautiful”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty Three")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("If you ever left,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    staticStyle: {
      "text-indent": "3em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("in rhyme.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The wind would")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" still come")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("   and the chimes would still play.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" sun would still rise")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("   and the moon would ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("end the day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-139"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The waves would still cras")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("h ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-139",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("   and the gulls would still caw.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("But")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-183",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("   I wouldn’t be the same. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-183",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("   Not at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Taylor Swift,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" “All Too Well”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty Four")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I have be")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("gun measuring life "), _c('br'), _vm._v("not just in numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d years")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-184"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but in sunsets and ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-184"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("trees blossoming ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and "), _c('br'), _vm._v("brilliant views.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You cannot ca")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lculate my growth by the notc")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hes ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("etched in the molding of my ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("bedroom wall. You ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("cannot under")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("stand my scars by the nicks ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("knees and elbows. You ca")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nnot grasp my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("metamorphosis by the s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("kin I’ve shed or")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the baby teeth I’ve lost.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It ca")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nnot be determined in anything I’ve lost or ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in what’s marred me. It can")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" only be quantified in ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("what remains, in")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" what withstood every storm ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and every ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("disruption of my heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You can see")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my growth simply by the fact th")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("at I ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("am still standing here, believing that")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" this world ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("is still an inherentl")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("y good place to laugh, to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hurt, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to love, to lose, to exis")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-36"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-36"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ade")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("le, “River Lea”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty Five")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("EWR to UAU")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You k")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("now something bad happened last nig")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ht, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but you don’t pry. You figure I’ll bring it up ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("when I’m ready. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We board the flight. We take ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("off. I remember")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" mumbling something to you ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("about how ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I never sleep on planes (g")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ranted, I ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("haven’t slept in my own bed in")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" some time, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("either). Suddenly, my body shuts down ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and I ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("slump onto your shoulder.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" Sleep found me ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("before 30,000 feet. I")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" wake a bit startled, a bit ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("surpris")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ed, and for the first time")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" in weeks (or has ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it been years?), a b")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it rested. ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("My mind was fin")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("ally ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("able to rest, knowing I ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("was flying far away from")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("here.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" You offer me")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" your neck pillow and a smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("urrently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Bruno M")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ars, “It Will Rain”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty Six")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I am under ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("construction. Not many people")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" like "), _c('br'), _vm._v("to admit that, but everyone")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" is always in the "), _c('br'), _vm._v("process of ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("becoming something else. No one is "), _c('br')]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ever really finished—constructed")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" and complete.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-185"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am starting to sl")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eep at a normal hour again. ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("So ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-185"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("that probably")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" means I am healing. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Sleep is th")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-185"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("first thing to leave you after")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" something like this. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-185"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Sanity foll")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ows soon after. The loss ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of one is ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-185"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("definitely directly related ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to the loss of the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I still ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have some trouble getting out of bed ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("come ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("morning, but I learned what ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("matters most is ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("getting out of bed at all. I’ve read about people ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("who")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" were so sad, they stayed in ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("bed all day. That ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("alone motivated me to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("want to get up, even if I just")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("moved to the couch. ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The couch ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("is not the bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A lot of what")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I knew left with you, and that")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("made me tired. Ask any sc")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hool-aged child, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("learning new thi")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ngs at times can be frustrating ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and dra")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ining. It hasn’t been a fluid progression ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of bad to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("better, but my repaired days have ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("begun to")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" outnumber my damaged ones.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Lis")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("tening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ruth B, “Lost ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Boy”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty Seven")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I used to love hotel ro")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("oms.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Now, the sheets feel stiff")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the unacquainted features")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of the room do not ho")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ld the same allure.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The white bedding")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("doesn’t ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("smell like the wet towel")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you absentmindedly left on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" our bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The pillowcases")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-186"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("don’t hold ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the distinct scent ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-186"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of your raven hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The air doesn’t smell")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("like")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" your cologne.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The closet ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("holds a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dripping iron")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but your sneakers are now")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("here to be found.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The room service I or")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dered ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("doesn’t include you,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-187"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sipping coffee across")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" from me, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-187"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("asking me about my day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-86"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-86"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lifeh")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ouse, “You and Me”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty Eight")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("To the guy ")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("who fell asleep on the couch:")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We’re private; many c")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an’t understand why we ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("don’t share every second of our lives ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("with the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("masses. Many get excited to have ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a wedding, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and wear the pretty")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" dress, and put on the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("expe")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nsive rings; but that one d")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ay in the scheme ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of “forever” ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that is celebrated annually doesn’t ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("really matter. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The stuff to really celebrate comes ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("after")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" that day. Choosing to stay tog")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ether. To ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("work on things. I’ve got")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" to be one of the most ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("difficult ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("people to love and remain in love")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" with; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’m sometimes selfish and my chaotic t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("houghts ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("translate into the mess")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I leave around our house. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’m independent in")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" most aspects of my life but ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("totally dependent when it")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" comes to you.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Without you, I’d fall apart.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" Some time ago,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-188"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I decided on forever, and ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am so very ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-188"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("fortunate you did, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("urrently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Jason M")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("raz, “I Won’t Give Up”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Sixty Nine")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Memories are mere echoes "), _c('br'), _vm._v("of the actual occurre")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("nce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Distorted in the reverberation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Romanti")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("cized in the ricochet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My ghos")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t towns were crowded ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for such a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("long time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-189"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You don’t haunt me anymore. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-189"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Memory lane ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("is just another street ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-189"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I turn left at on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my way to")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-51"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the grocery store now. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-51"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I prefer it this way.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently List")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ening To: "), _c('br'), _vm._v("Beyonc")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("é")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(", “Sorry")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Scraped knees. Black eyes. Tears.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-101"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("This is all pain we can see. Pain w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e can aid. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-101"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Pain that will heal if ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("we tend and mend.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then, there is ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("that")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" other pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The pain so embedded into")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" our being, so deep, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that it ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("fuses to our existence and mixes with")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" our "), _c('br'), _vm._v("bloodstream. It doesn’t just become a part of us, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it bec")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("omes who we are.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It’s that other pain ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you can’t see that never ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("really heals, not fully a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nyway. It’s also the pain ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that gives us a higher")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" purpose. The kind of pain ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-30"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that will turn")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" you into a warrior.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-113"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Those masc")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ara streaks are your war paint; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-113"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ear them proudly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-109"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ing To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-109"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Big Sean, “Deep”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy One")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I am too focused on my next move ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("to worry "), _c('br'), _vm._v("about what everyone on earth i")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("s doing next. I "), _c('br'), _vm._v("don’t need to beat down who I w")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("as yesterday, or "), _c('br'), _vm._v("anyone else for that matter, to grow. I don’t take "), _c('br'), _vm._v("a")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("dvantage of the disadvantages of")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" others. I "), _c('br'), _vm._v("refuse to race against ti")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("me, other women, or "), _c('br'), _vm._v("men. I can on")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ly reach my next level,"), _c('br'), _vm._v("not anyone else’s")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-35"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I compete with my own benchmark")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-35"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my own comfort zones,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-190"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my ow")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n inner strength, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-190"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and my own")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ti")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("m McGraw, “Humble and Kind”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy Two")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I have demanded to speak to God directly")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" three "), _c('br'), _vm._v("times. Three times in three")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" decades is not a lot, "), _c('br'), _vm._v("I’d say. I found ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Him the other night, in a "), _c('br'), _vm._v("different place than")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" I found Him last.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The first tim")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e I found Him wading within")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the crests")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" of waves of water too cold to swim.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("second time, I found Him sl")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eeping")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("inside the thread count ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of my beloved’s sheets.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-27"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("This time I fou")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nd Him stitched into ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-27"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the song ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of my mother’s wind chimes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I had g")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("one outside to catch my breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-191"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Outside t")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("here is more air,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-191"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("enough air to save me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-192"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I had my heartbreak, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-192"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I had my ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("breakdown,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("now I needed my breakthrou")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("gh.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("At that very moment,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the unmistakable win")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d that bridged seasons ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("blew through ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my unwashed hair")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-193"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and the trees an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d the metal cylinders ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-193"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my mother attached ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to their branches ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-193"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and He s")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ang to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("His melody calmed ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("me")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and I was able to hear the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("crickets")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and my family conversing at ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the dinner table ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and the static from my father’s record pla")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("yer ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("over the pounding in my head an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d heart again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-191"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I was brought out")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" of the past ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-191"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and placed into ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the present.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-150"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("That’s the thing about faith; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-150"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("if")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" you are looking,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you will find it;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-194"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("if you need it, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-194"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you will fi")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nd it;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-194"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("if you believe, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-194"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you will f")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ind it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listening T")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("o: "), _c('br'), _vm._v("Christina Grimmie, “I Bet Yo")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("u Don’t Curse God”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy Three")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Yesterday ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("was a good day. I woke up easy, sl")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ow. "), _c('br'), _vm._v("The smell from the air con")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ditioner in my "), _c('br'), _vm._v("window welcomed me ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("like the warm")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("aroma of coffee brewi")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ng.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yesterday was a good day. The fore")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("cast called for ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("rain, but th")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e sun shined all day. I read a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("book in ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my hammock. The battery ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in my phone lasted an"), _c('br'), _vm._v("impres")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sive seven hours. The clothes I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ordered ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("got delivered and everything fit ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("perfectly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yesterday was a good day. The barista")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" made my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("latte perfectly and there")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" was no line at the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("pharmacy.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" There were no shadows, no omin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ous ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("clouds, and three of my favorite ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("songs played in ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-69"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a row on the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("radio.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yesterday was a good day")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("even though y")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ou didn’t come back.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-195"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My heart noticed the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" shift ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-195"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ing To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Maren Morris, “Rich”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy Four")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I am the most put-together br")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("oken person you "), _c('br'), _vm._v("will ever come across;")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" with hairline fractures so "), _c('br'), _vm._v("fine, ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("my skin remains smooth to the touch.")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" I see "), _c('br'), _vm._v("I am shattered; broken shards placed")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" together "), _c('br'), _vm._v("and called art, ")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("a mosaic")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("ked woman.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Are you having another ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("one of your dark days?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My father")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" asks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Days in a daze become ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("weeks of being weak. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Months ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("become moths that eat holes into")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" my ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-34"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("favorite moments.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("There was a ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("time I laughed more, was more ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lighthearted ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and whimsical. There was a time I")]), _c('span', {
    staticClass: "CharOverride-5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("smiled in more than just pictures. ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("There was ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("once a time I at l")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("east attempted to end pieces on ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-45"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("high notes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ll get back there.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("See? A high note.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-165"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-165"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ben Rector, “F")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ear”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy Five")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("The ocean resides outside where my ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("parents "), _c('br'), _vm._v("stay. I breathe in deep. I")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" like the smell of "), _c('br'), _vm._v("summer, but the")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" thought of winter")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("keeps me warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Decemb")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("er was when you loved me last.")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" Your ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("mind shifted from me before your heart ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("left. The ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("crashing waves sound li")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ke the dishes I threw ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("against th")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e wall that night.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("If I am broken,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" the plates we eat ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("on should be broken, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-196"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Seagulls caw in the distance, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-196"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d I am tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Tired of tirelessly cryi")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ng")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("over the same old bullshit story.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I love ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("you,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("but not right now.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I want ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("you,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("but not right now.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The humidity in the air has caused"), _c('br'), _vm._v("my footprints to create a trail on the tile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Now my mother is going to be able to tell"), _c('br'), _vm._v("I have")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" been walking in circles.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ve al")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ways preferred hardwood floors")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but being so close to the ocean ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("doesn’t allow it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The salt in the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("air can cause ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("structural damage to the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("wood; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("any beach kid knows")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" this.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-185"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ve always preferred you over any other man ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-185"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("but bei")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ng so close to you doesn’t a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("llow it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The hurt in the air can c")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ause")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("structural damage to my heart;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("any brokenhearted")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v(" woman knows this.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Carrie Underwood, “Little")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Toy Guns”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy Six")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Darkness is like a s")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("leeping bear— "), _c('br'), _vm._v("it should not be po")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ked, provoked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Still, too many I know")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" are hunting")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-198"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("down nightmares, pissing aw")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ay the same ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-198"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("time life allots to cha")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("se dreams.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I can’t take it anymore, honestl")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("y,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("all this darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I have los")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("t my voice")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("trying to convince people ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I love ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of their own poten")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("tial.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-140"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I have been the collateral damage ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-140"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to a number of life tragedies")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that were not direc")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("tly my own.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-199"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ve swept up messes I haven’t created ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-199"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("dried tears I haven’t cried.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ve aged just by witness")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ing others lose years.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-186"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Self-destruction ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("destroys ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-186"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("more than just the individual.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("urrently Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Christina P")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("erri, “Butterfly”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy Seven")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Let’s be clear. I did n")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ot accidently step into my "), _c('br'), _vm._v("life. I loved and ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("worked every single day. A good "), _c('br'), _vm._v("thing ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("happening to a good person is")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" not luck. "), _c('br'), _vm._v("Just like how a bad t")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("hing happening to a bad person "), _c('br')]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("is not bad luck. Sometimes, it’s just life. I’ve "), _c('br'), _vm._v("been hurt. I’ve ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("cried into my pillow. I’ve "), _c('br'), _vm._v("experienced loss. I have ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("been overlooked and "), _c('br'), _vm._v("underestimated more times than I’d like to "), _c('br'), _vm._v("admit. ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I have experienced moments"), _c('br'), _vm._v("of good fortune.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Life is")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" all about balance;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-130"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am a firm believer ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("that you get "), _c('br'), _vm._v("what you give in this world.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yes, I am loved—")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("bec")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ause I love.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-200"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Yes, I am taken care of")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("— "), _c('br')]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("because I take care of others.")]), _c('span', {
    staticClass: "CharOverride-2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-200"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Yes, I have friends—")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("because I am")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" a friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-159"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am not going to apol")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ogize for my life, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-159"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("just like how life did")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" not apologize")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to me when things weren’t going my way.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("urrently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Maren Mo")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("rris, “Second Wind”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy Eight")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I hol")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("lowed out my memory;")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("to make room for ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("what’s to come.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I scooped out the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" gunk;")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the letdowns, the heartache,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nd left the happiness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Yet, I was ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("no longer myself;")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("unbalanced")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Maybe I")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" was meant to be sad")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(", I tho")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ught.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I plopped back in the painful ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("an")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("d scooped out the happiness; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-28"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the wedding")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("s, the graduations,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the moments I laughed unt")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("il I cried.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Once again I found my")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("self unstable. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We need both.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("We need ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the good")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and the bad")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to be who we are.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("For better or worse, we need both.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("urrently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ingrid Mi")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("chaelson, “Drink You Go")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ne”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Seventy Nine")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Your face jolted me from sleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The details do not matter,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("because you no ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("longer matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I startled the man sl")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("eeping next to me;")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the man who matters.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("What")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" is it?")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" he asked, concerned.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Nothi")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ng. It was just a nightmare.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I wasn’t lying.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Billy")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Currington, “It Don’t Hurt")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Like It Used To”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I believe ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("in what destroyed me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-202"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I believe it needed to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("destroy me. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-202"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My pain is not in vain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("What I went through ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("replaced my backbone,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("o")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("nce as brittle as a wishbone, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ith a sword.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ing To: "), _c('br'), _vm._v("Whitney Houston, “It’s")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Not Right but It’s Okay”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty One")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("When")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" I was leaving your funeral, "), _c('br'), _vm._v("churc")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("h bells sang announcing "), _c('br'), _vm._v("another hour in")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" my life,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("another hour lived without you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Birds chirped")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and I heard a sprinkler ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sprayin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g water on grass")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("already too green ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for its own good.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("It would ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("have been a great day")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("if it wa")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sn’t already the worst day of my ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-169"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Across from the church was")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" a playground; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-169"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("children swung on th")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e swings,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in tune to the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("bells.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-203"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A child’s eyes met mine; ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-203"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("they were warm, welcoming.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Not only was life still going o")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it was still smiling at me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("urrently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-39"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Luke B")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ryan, “Drink a Beer”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty Two")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I do believe")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" the sun will come out after each")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_c('br'), _vm._v("storm, though no one know")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("s how long one of "), _c('br'), _vm._v("life’s storms ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("will last.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Could be a passin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g shower, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("could be a yearlong m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("onsoon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You aren’t a fictional")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" green witch;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you will not melt if yo")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("u get a little wet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-54"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I would say ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("learn to dance in the rain")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-54"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("but ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("that’s too much of a Goddamn cliché")]), _c('span', {
    staticClass: "CharOverride-2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-54"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("these days; at the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("very least,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-204"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("find the simple joy of jumpi")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ng ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-204"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the puddles life creates.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Curre")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ntly Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Gene Kelly,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" “Singin’ in the Rain”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty Three")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Some t")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("hings slow my world down")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_c('br'), _vm._v("but nothing has truly")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("stopped it from spin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I don’t give up;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-183"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("even when I feel defeated ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-183"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and proclaim,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I give up,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I never really")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" do.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("What I’ve been carrying quietly ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on my shoulders")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" for years")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you wouldn’t be able to hoist ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-149"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("onto your back ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for one day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The loudest people ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the room ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("aren’t always the most heard, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the people cryin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g the loudest ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-123"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("aren’t always the most hurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Cu")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("rrently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-21"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Christina Agu")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ilera, “Fighter”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty Four")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I still miss ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("you from time to time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-103"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("What’s changed is how ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ve begun ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-103"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to handle ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("the missing")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ve lear")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ned that pain passes;")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the missing")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(", it pas")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ses.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Much like a dizzy spell,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("just have to wait until my")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" vision")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-55"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and mind clear and the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" aching clears, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-55"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("That’s how I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("healed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I woke up every day,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-126"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("cried or didn’t cry, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-126"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("re")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("gained my balance,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and went the hell ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("on with my day,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-35"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("which eventually turned")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" into me ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-35"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("getting the hell on ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("with my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listeni")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ng To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Gloria Gaynor, “I W")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ill Survive”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty Five")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("If you are feeling ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("lost, "), _c('br'), _vm._v("helpless,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("down,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-205"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("sad, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-205"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("angry, "), _c('br'), _vm._v("betrayed,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("you name it,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-206"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you can rise from it, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-206"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("can create from it, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-206"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you can grow from ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I am living proof")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-207"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the most turbulent ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("year of one’s life ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-207"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("could also turn ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("out to be")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the greatest, more rewarding y")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ear, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("lorida Georgia Line, “May")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" We All”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty Six")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Some weekend mornings in")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" my new home, "), _c('br'), _vm._v("I wake up to the ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("bark of the dog in the "), _c('br'), _vm._v("con")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("necting yard. When I do, for a")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" second, I "), _c('br'), _vm._v("believe it’s the bark of")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" my family dog.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The dog that still sleeps ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("an hour away in the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("house where ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I grew up, with the family I see")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" far ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("less than I wish. The dog we’ve")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" had since I was ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("thirteen years old. The ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("aging dog who spends ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("more time with ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my parents than I do.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Now, I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("know it is not him I hear; but ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("for a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("moment I am back in my old")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" bedroom, in the ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("busy home where I ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("shared a wall, computer, and ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("clothes ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("with my sister and a bathroom with ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("four ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("other people. I am back, hearin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("g pots clanging ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and sauce simmering in ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my mother’s kitchen.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Then, I fully awake, an")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("d I am in my new home. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Though")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" I wake alone in a quiet h")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ouse some ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("mornings, I find ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("comfort in the notion of ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("home")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You do")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n’t have to remember to take")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" Home with ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you when you move on; ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you carry Home in your ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("heart, and on")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" some really lucky days, Home ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-33"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("visits you through t")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("he bark of a stranger’s pet.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ing To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Crosby, Stills, Nash & Young, “Our ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("House”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty Seven")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I accomplished everythin")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("g in my life "), _c('br'), _vm._v("in spite of you, not")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" because of you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You can’t take my happin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ess from me anymore, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("because you are no longer the")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" underlying reason. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You can’t take someth")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ing back from someone ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-41"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("you never even held in ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("your own two hands")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in the fir")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("st place.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-208"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("You do not hold my happines")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("s. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-208"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("You do not own my happiness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-208"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I manifest my ow")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("n happiness.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-168"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I came this far on ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a broken heart—")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-168"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("functioning at maybe, on ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("a good day, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-168"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("forty percent efficiency.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I thin")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("k you should be nervous")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("about what I will")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" accomplish once I heal.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-75"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The mountains I’ll ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("move. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-75"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The miles I’ll cover.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The skin I’ll get under")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Sia, “Alive”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty Eight")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I don’t belong here;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-209"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’m out of sync with")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" what’s around me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-209"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My heart doesn’t belong here;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("it beats out ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("of time,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("like a drum in the w")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("rong song.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Oh, how I wish for")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" a breeze to find me;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-160"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’d scatter like confetti ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-160"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to the air,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-78"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ending up in one mil")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("lion "), _c('br'), _vm._v("different places at once.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("What a magical ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("escape.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listening T")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("o: ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ryn Weaver, “Pierre”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Eighty Nine")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("He lo")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("oks in my eyes and he kn")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ows he’s lost me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Not forever but for the")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" next few hours.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("My stare is unfocus")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("ed;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-202"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the sadness simmering inside of me ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-202"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("has")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" boiled to the surface.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I feel every")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" organ that matters:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("my lungs, my heart, my brain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-42"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("They")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" have become heavy, "), _c('br'), _vm._v("weighing m")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("e down in bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("He looks i")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("n my eyes and knows ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-98"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I’ll ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("be back soon enough;")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("so he")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" rests beside me,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("making sure he’s the ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("first thing")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I will see when ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my heart wakes up again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Currently Li")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("stening To: "), _c('br'), _vm._v("Miranda Lambert,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" “Runnin’ Just in Case”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Ninety")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" find myself singing")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to the r")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("hythm of your breathing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You know ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the doors")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-64"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("to all four chambers of my")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-210"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You know which creak ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-210"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" which open freely.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Most importantly, you ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("know")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-211"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("how to pry open the jammed doors ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-211"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("so")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" many others confused for locked.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" push with all your might, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-32"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I let you in.")])]), _vm._v(" "), _c('p', {
    staticClass: "Song-TitleA ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Listen")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ing To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-59"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Train, “Meet Virginia”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Ninety One")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Doors remain ajar as long as t")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("wo people allow. "), _c('br'), _vm._v("Once someo")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ne makes the decision to leave, "), _c('br'), _vm._v("the")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" ajar door slams shut right b")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ehind them "), _c('br'), _vm._v("with the wind ")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("and the letdowns.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-101"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You cannot re")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("enter once this happens. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-101"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You cannot")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" reenter that life ever again.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("You’re no longer an invited guest,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("you are an intruder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Curre")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ntly Listening To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Luminee")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("rs, “Stubborn Love”")])]), _vm._v(" "), _c('p', {
    staticClass: "TrackB"
  }, [_vm._v("Track Ninety Two")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Gatheri")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ng rays, seashells, and memories. "), _c('br')]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I collect my thoughts along")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" the seashore.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text2 ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I place one close to ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("my ear. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text ParaOverride-66"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I listen intently.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Breathe in")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(", breathe out,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("you’ve made it to")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" the other side.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal3 ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Currently Liste")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("ning To:")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-22"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Band Perry, “Come")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("back Kid”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a3c3116","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StuffIveBeen_mobi.vue
// module id = 60
// module chunks = 0